export default __webpack_public_path__ + "static/media/checkbox_off.1cd68665.svg";